'use strict'

// assign :: a -> Object -> Object
const assign = props => object => Object.assign({}, object, props)

// bind :: (a -> b) -> (b -> a -> c) -> a -> c
const bind = (f, g) => o => g(f(o))(o)

const registrar = list => fn => {
  list.push(fn)
  return () => {
    const index = list.indexOf(fn)
    if (index >= 0) {
      list.splice(index, 1)
    }
  }
}

module.exports.assign = assign
module.exports.bind = bind
module.exports.registrar = registrar



// WEBPACK FOOTER //
// ./recordStore/utils.js